import { FC } from "react";

import { ViewfinderProps } from "@/components/GalleryUploader/Camera/Camera.types";
import { PrimaryText } from "@/components/Typography/Styled";

import { StyledViewfinder } from "./Styled";

export const Viewfinder: FC<ViewfinderProps> = (props) => {
    return (
        <StyledViewfinder {...props}>
            <PrimaryText className="help-text" $textColor="error">
                Вирівняйте телефон, щоб зробити фото
            </PrimaryText>
        </StyledViewfinder>
    );
};
